// src/plugins/primevue.js
import PrimeVue from 'primevue/config'
import Aura from '@primeuix/themes/aura';
import 'primeicons/primeicons.css'

// Импортируйте все компоненты
import Button from 'primevue/button'
import Toolbar from 'primevue/toolbar';
import FileUpload from 'primevue/fileupload';
import Card from 'primevue/card';
import Splitter from 'primevue/splitter';
import SplitterPanel from 'primevue/splitterpanel';
import Menubar from 'primevue/menubar';
import Panel from 'primevue/panel';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import Badge from 'primevue/badge';
import Select from 'primevue/select';
import InputNumber from 'primevue/inputnumber';
import Password from 'primevue/password';
import ToastService from 'primevue/toastservice';
import Toast from 'primevue/toast';

import FloatLabel from 'primevue/floatlabel';
import ButtonGroup from 'primevue/buttongroup'
import Dialog from 'primevue/dialog';
import RadioButton from 'primevue/radiobutton';
import ConfirmPopup from 'primevue/confirmpopup';
import ConfirmationService from 'primevue/confirmationservice';


import Textarea from 'primevue/textarea';



import SelectButton from 'primevue/selectbutton';

export default {
  install(app) {
    // Подключаем PrimeVue с темой
    app.use(PrimeVue, {
      theme: {
        preset: Aura,
        options: {
          prefix: 'p',
          darkModeSelector: '.p-dark'
        }
      },
      ripple: true
    })
    
    // Подключаем ToastService
    app.use(ConfirmationService)
    app.use(ToastService);
    
    // Регистрируем все компоненты глобально
    const components = {
      Button, Toolbar, FileUpload, Card, Splitter, SplitterPanel, 
      Menubar, Panel, DataTable, Column, InputText, Toast, Badge, 
      Select, InputNumber, Password, FloatLabel,ButtonGroup,Dialog,RadioButton,ConfirmPopup,SelectButton,
      Textarea
    }
    
    Object.entries(components).forEach(([name, component]) => {
      app.component(name, component)
    })
    
    console.log('✅ PrimeVue плагин загружен')
  }
}